// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Fechamentos_IndexInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /fechamentos
 *
 * Validates query parameters for listing monthly accounting periods.
 */
import { registerContract } from './validate'

export interface Fechamentos_IndexInput {
franquia_id?: number
status?: string
data_inicial?: string
data_final?: string
page?: number
per_page?: number
}

registerContract('Fechamentos_IndexInput', {
  franquia_id:  { type: 'number',  required: false },
  status:       { type: 'string',  required: false },
  data_inicial: { type: 'string',  required: false },
  data_final:   { type: 'string',  required: false },
  page:         { type: 'number',  required: false },
  per_page:     { type: 'number',  required: false },
})
